<ion-input [placeholder]="placeholderLong"
           [inputmode]="'decimal'"
           (ionInput)="onInput($event)"
           [formControl]="formControl">
</ion-input>
